import { useState } from "react";
import validator from "validator";
import { useNavigate, Link } from "react-router-dom";
import {
  registerRider,
  mailVerification,
} from "../../../../../lib/webService/webService";
import { toast } from "../../../../../utilities/toast";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { Seo } from "../../../../../components/Seo";
import { generateNoIndexSEO } from "../../../../../lib/seo/metaGenerators";

if (typeof document !== "undefined" && !document.getElementById("or-styles")) {
  const s = document.createElement("style");
  s.id = "or-styles";
  s.textContent = `
    .or-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;background:#F2F2F7;padding:32px 16px;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Display","Helvetica Neue",Arial,sans-serif}
    .or-card{background:#fff;border-radius:20px;padding:36px 28px 32px;width:100%;max-width:460px;box-shadow:0 2px 16px rgba(0,0,0,.07)}
    .or-input{width:100%;background:rgba(118,118,128,.10);border:1.5px solid transparent;border-radius:10px;padding:11px 14px;font-size:.9375rem;color:#1c1c1e;outline:none;transition:border-color .18s,box-shadow .18s;box-sizing:border-box;font-family:inherit}
    .or-input:focus{border-color:#007AFF;box-shadow:0 0 0 3px rgba(0,122,255,.12)}
    .or-input::placeholder{color:rgba(60,60,67,.38)}
    .or-btn{width:100%;padding:13px;border-radius:12px;border:none;font-size:.9375rem;font-weight:600;cursor:pointer;font-family:inherit;transition:opacity .15s;display:flex;align-items:center;justify-content:center;gap:8px}
    .or-btn:disabled{opacity:.55;cursor:not-allowed}
    .or-btn-primary{background:#007AFF;color:#fff}
    .or-btn-primary:active{opacity:.82}
    .or-label{font-size:.8125rem;font-weight:500;color:rgba(60,60,67,.65);margin-bottom:6px;display:block}
    .or-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}
    .or-pw-wrap{position:relative}
    .or-pw-eye{position:absolute;right:12px;top:50%;transform:translateY(-50%);background:none;border:none;padding:0;cursor:pointer;color:rgba(60,60,67,.45);display:flex;align-items:center}
    .or-err{background:rgba(255,59,48,.08);border:1px solid rgba(255,59,48,.18);border-radius:10px;padding:10px 14px;color:#FF3B30;font-size:.875rem;margin-bottom:16px;display:flex;justify-content:space-between;align-items:flex-start;gap:8px}
    @keyframes _or_spin{to{transform:rotate(360deg)}}
    ._or_spin{width:16px;height:16px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:_or_spin .7s linear infinite;flex-shrink:0}
  `;
  document.head.appendChild(s);
}

const OperationsRegister = () => {
  const [firstName, setFirstName]                   = useState("");
  const [lastName, setLastName]                     = useState("");
  const [idNumber, setIdNumber]                     = useState("");
  const [bikeNumber, setBikeNumber]                 = useState("");
  const [phoneNumber, setPhoneNumber]               = useState("");
  const [inputEmail, setInputEmail]                 = useState("");
  const [inputPassword, setInputPassword]           = useState("");
  const [inputConfirmPassword, setInputConfirmPassword] = useState("");
  const [error, setError]                           = useState({ isErr: false, message: "" });
  const [loading, setLoading]                       = useState(false);
  const [showPassword, setShowPassword]             = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!inputEmail || !inputPassword || !inputConfirmPassword) {
      setError({ isErr: true, message: "All fields are required." });
      return;
    }

    if (!validator.isEmail(inputEmail)) {
      setError({ isErr: true, message: "Invalid email format" });
      return;
    }

    if (inputPassword !== inputConfirmPassword) {
      setError({ isErr: true, message: "Passwords do not match" });
      return;
    }

    if (inputPassword.length < 6) {
      setError({ isErr: true, message: "Minimum password length is 6" });
      return;
    }

    if (inputPassword.length > 16) {
      setError({ isErr: true, message: "Maximum password length is 16" });
      return;
    }

    setLoading(true);
    try {
      const data = await registerRider({
        firstName,
        lastName,
        phoneNo: phoneNumber,
        email: inputEmail,
        nationalId: idNumber,
        motorNo: bikeNumber,
        password: inputPassword,
      });

      if (data) await mailVerification(inputEmail, data.actionLink);
      navigate(`/auth/verify?email=${encodeURIComponent(inputEmail)}`);
    } catch (err) {
      toast.error(err?.message || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const Field = ({ label, children }) => (
    <div style={{ marginBottom: 14 }}>
      <label className="or-label">{label}</label>
      {children}
    </div>
  );

  return (
    <div className="or-wrap">
      <Seo {...generateNoIndexSEO("Rider Sign Up")} />
      <div className="or-card">

        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img
            src="/imgs/logo/complete-250.png"
            alt="Logo"
            style={{ width: 72, height: 72, objectFit: "contain", marginBottom: 16 }}
          />
          <div style={{ fontSize: "1.375rem", fontWeight: 700, color: "#1c1c1e", letterSpacing: "-0.02em" }}>
            Rider Registration
          </div>
          <div style={{ fontSize: "0.875rem", color: "rgba(60,60,67,0.55)", marginTop: 4 }}>
            Create your rider account
          </div>
        </div>

        {error.isErr && (
          <div className="or-err">
            <span>{error.message}</span>
            <button
              onClick={() => setError({ isErr: false, message: "" })}
              style={{ background: "none", border: "none", color: "#FF3B30", cursor: "pointer", padding: 0, lineHeight: 1, flexShrink: 0 }}
            >✕</button>
          </div>
        )}

        <form onSubmit={handleSubmit}>

          <div className="or-grid" style={{ marginBottom: 14 }}>
            <div>
              <label className="or-label">First Name</label>
              <input className="or-input" type="text" placeholder="First name" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
            </div>
            <div>
              <label className="or-label">Last Name</label>
              <input className="or-input" type="text" placeholder="Last name" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
            </div>
          </div>

          <Field label="Phone Number">
            <input className="or-input" type="tel" placeholder="Enter phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
          </Field>

          <Field label="Email Address">
            <input className="or-input" type="email" placeholder="Enter email" value={inputEmail} onChange={(e) => setInputEmail(e.target.value)} required />
          </Field>

          <div className="or-grid" style={{ marginBottom: 14 }}>
            <div>
              <label className="or-label">National ID No</label>
              <input className="or-input" type="text" placeholder="ID number" value={idNumber} onChange={(e) => setIdNumber(e.target.value)} required />
            </div>
            <div>
              <label className="or-label">Bike Reg No</label>
              <input className="or-input" type="text" placeholder="Reg number" value={bikeNumber} onChange={(e) => setBikeNumber(e.target.value)} required />
            </div>
          </div>

          <Field label="Password">
            <div className="or-pw-wrap">
              <input
                className="or-input"
                type={showPassword ? "text" : "password"}
                placeholder="Create password"
                style={{ paddingRight: 40 }}
                value={inputPassword}
                onChange={(e) => setInputPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
              <button type="button" className="or-pw-eye" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <EyeSlash size={17} /> : <Eye size={17} />}
              </button>
            </div>
          </Field>

          <Field label="Confirm Password">
            <input
              className="or-input"
              type={showPassword ? "text" : "password"}
              placeholder="Confirm password"
              value={inputConfirmPassword}
              onChange={(e) => setInputConfirmPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </Field>

          <div style={{ marginTop: 8 }}>
            <button type="submit" className="or-btn or-btn-primary" disabled={loading}>
              {loading ? <><span className="_or_spin" />Creating account...</> : "Create Account"}
            </button>
          </div>

        </form>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: "0.875rem", color: "rgba(60,60,67,0.55)" }}>
          Already have an account?{" "}
          <Link to="/login" style={{ color: "#007AFF", textDecoration: "none", fontWeight: 500 }}>
            Login
          </Link>
        </div>

      </div>
    </div>
  );
};

export default OperationsRegister;
